import WorksheetStatus from 'Components/Worksheets/Core/WorksheetStatus';
import React, { Component } from 'react';
import Button from '../../../Core/Button';
import Dialog from '../../../Core/Dialog/Dialog';
import Field from '../../../Core/Field';
import Link from '../../../Core/Link';
import TextOutput from '../../../Core/TextOutput';

//Interface for each Sibling TestLink
export interface ILinkTestLink {
  testName: string;
  testUUID: string;
  testStatusHeader: any;
  isWorksheet: boolean;
}
/**
 * A dialog that show list of links that redirect to other tests
 * when clicked on
 */

export interface ILinkTestsDialogProps {
  confirm?: boolean | ((event: any) => boolean);
  name?: string;
  messageTitle?: string;
  siblingTests?: ILinkTestLink[];
  messageButtonText?: string;
  messageDialogWidth?: string;
  alwaysEnabled?: boolean;
}
class LinkTestsDialog extends Component<React.PropsWithChildren<ILinkTestsDialogProps>, any, any> {
  static idCounter = 0;

  constructor(props: ILinkTestsDialogProps) {
    super(props);
    this.state = {
      dialogVisible: false,
      linkTestsDialogId: LinkTestsDialog.idCounter++,
    };
  }

  eventInterceptedChildren() {
    const child: any = React.Children.only(this.props.children);
    let { onClick } = child.props;
    const props: any = {};
    // Intercept events, and conditionally fire them.
    switch (child.type) {
      case Button:
        props.onClick = (evt: any) => {
          this.setState({ dialogVisible: true });
          if (onClick) onClick(evt);
        };
        break;
      default:
        throw new Error(`<ListTestDialog> does not support type '${child.type}'.`);
    }
    return React.cloneElement(child, props);
  }

  render() {
    const { messageDialogId } = this.state;
    const {
      name = `messageDialog_${messageDialogId}`,
      messageTitle = 'Message',
      siblingTests = [],
      messageButtonText = 'OK',
      messageDialogWidth = '400px',
      alwaysEnabled,
    } = this.props;
    return (
      <>
        <Dialog
          name={name}
          title={messageTitle}
          buttons={[
            <Button
              key="0"
              name={`${name}.buttonOk`}
              alwaysEnabled={alwaysEnabled}
              onClick={() => this.setState({ dialogVisible: false })}
            >
              {messageButtonText}
            </Button>,
          ]}
          alwaysEnabled={alwaysEnabled}
          visible={this.state.dialogVisible}
          onClose={() => this.setState({ dialogVisible: false })}
          width={messageDialogWidth}
        >
          {siblingTests?.map(({ testName, testStatusHeader, isWorksheet, testUUID }: ILinkTestLink) => (
            <div style={{ display: 'flex', padding: '5px' }}>
              <span className="FixedPageHeader-StatusIcon">
                <WorksheetStatus status={testStatusHeader} />
              </span>
              {isWorksheet ? (
                <Link to={`/worksheets/${testUUID}`} openInNewTab>
                  {testName}
                </Link>
              ) : (
                <Field input={<TextOutput />} value={testName} />
              )}
            </div>
          ))}
        </Dialog>
        {this.eventInterceptedChildren()}
      </>
    );
  }
}

export default LinkTestsDialog;
export { LinkTestsDialog };
